(function () {

    'use strict';

    function definition(enums, App, Backbone, Marionette, $, _) {

        enums.tweetTypes = {
            normal: {
                name: 'normal',
                id: 1
            },
            retweet: {
                name: 'retweet',
                id: 2
            },
            reply: {
                name: 'reply',
                id: 3
            }
        };
    }

    if (typeof window === 'undefined') {
        const App = {
            enums: {}
        };
        definition(App.enums, App);
        module.exports = App.enums.tweetTypes;
    } else {
        RivalIQ.module('enums', definition);
    }

}());
